<template>
  <video-player
    ref="videoPlayer"
    :playsinline="true"
    :options="playerOptions"
    class="vjs-big-play-centered"
    style="border: 3px solid #162b44"
  />
</template>
<script>
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';

export default {
  name: 'ViewVideoPlayer',
  components: {
    videoPlayer,
  },
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  mounted() {
  },
  computed: {
    playerOptions: function() {
      const options = {
        autoplay: false,
        preload: 'auto',
        responsive: true,
        fluid: true,
        controls: true,
        sources: [
          {
            type: 'video/mp4',
            src: this.selectedVideo.file.data.url,
          },
        ]
      }
      if (this.selectedVideo.file.data.cc_path) {

        options.tracks = [
          {
            kind: "captions",
            label: "English",
            srclang: "en",
            src: this.selectedVideo.file.data.cc_path,
            default: true
          }
        ]
      }
      return options;
    },
    selectedVideo: function () {
      return this.$store.getters.currentVideo;
    },
    playVideo: function () {
      return this.$store.getters.playVideo;
    },
    entity: function () {
      return {
        related_entity: this.$store.getters.coursePlayer.id,
        related_entity_asset_id: this.selectedVideo.id,
        entity_lookup_user_id: this.$store.getters.userStats.id,
        entity_type: 1, //course
      };
    },
    totalWatchedVideos: function () {
      return this.$store.getters.userStats.watched.data.length;
    },
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch: {
  },
  methods: {
  },
};
</script>